import { Controller } from '@hotwired/stimulus';

/**
 * Events component.
 */
export default class extends Controller {
    static targets = [
        'navigation',
        'mobileToggle',
        'dropdown',
    ];

    connect() {
        const me = this;
        const $navigation = $(this.navigationTarget);
        const $mobileToggle = $(this.mobileToggleTarget);

        // Watch click on menu item titles.
        $navigation.on('click', '.menu-item--expandable > .menu-item-title', function (event) {
            event.stopPropagation();

            const $menuItem = $(this).parent();
            const $menu = $menuItem.parent();
            const isMainMenu = $menu.hasClass('menu');
            const isActive = $menuItem.hasClass('show');

            const $dropdownMenu = $(this).siblings('.dropdown-sub-menu');

            if ($dropdownMenu.css('display') === 'block') {
                $(this).parent().removeClass('show');
                $dropdownMenu.css('display', 'none');
            }

            // Check if main menu item or sub menu item :after toggle icon was clicked.
            const toggleWidth = parseInt(window.getComputedStyle(this, '::after').width, 10);
            if (isMainMenu || event.offsetX > this.offsetWidth - toggleWidth) {
                // Stop location change by link (if any).
                event.preventDefault();
                
                const isLanguageMenu = $menu.closest('.menu.language').length > 0;
                const animate = isLanguageMenu;

                // Close all other menus not containing the clicked menu item.
                me.#toggle(
                    me.#getExpandableMenuItems().filter(
                        (_i, el) => $(el).hasClass('show') &&
                            !$(el).has(this).length
                    ),
                    false,
                    animate
                );

                // Show/hide clicked sub menu.
                me.#toggle(
                    $menuItem,
                    !isActive,
                    animate
                );
            }

            // Focus search input on sub menu open.
            if (!isActive && $menu.hasClass('search')) {
                window.setTimeout(function () {
                    $menu.find('.input-search')[0].focus();
                }, 500);
            }
        });

        // Watch click on submenu close toggles.
        $navigation.on('click', '.menu-close', () => {
            // Close all open menus.
            this.closeMenus();
        });

        // Watch click on submenu close toggles.
        $mobileToggle.on('click', (e) => {
            e.preventDefault();
            $mobileToggle.toggleClass('is-active');
            $navigation.toggleClass('show', $mobileToggle.hasClass('is-active'));
        });
    }

    /**
     * Close all open menus.
     */
    closeMenus() {
        // debugger;
        const $navigation = $(this.navigationTarget);
        const $mobileToggle = $(this.mobileToggleTarget);

        this.#toggle(this.#getExpandableMenuItems().filter('.show', false));

        $mobileToggle.removeClass('is-active');
        $navigation.removeClass('show');
    }

    /**
     * Close open dropdown menu.
     */
    closeDropdownMenu(event) {
        const dropdownMenu = event.target.closest('.dropdown-sub-menu');
        const subMenus = $(this.navigationTarget).find('.menu .menu-item--expandable');

        if (dropdownMenu) {
            $(dropdownMenu).slideUp('fast');
            subMenus.removeClass('show');
            this.updateOverlay();
            this.#syncHeaderMenuState();
        }
    }


    // private

    updateOverlay() {
        const subMenuLang = $(this.navigationTarget).find('.menu.language .menu-item--expandable');
        const overlay = $('.overlay-header');

        if (subMenuLang.filter('.show').length > 0) {
            $('.header-navigation').addClass('lang-modal-open');
            overlay.stop(true, true).fadeIn(300);
        } else {
            $('.header-navigation').removeClass('lang-modal-open');
            overlay.stop(true, true).fadeOut(300);
        }
    }


    #getExpandableMenuItems() {
        return $(this.navigationTarget).find('.menu .menu-item--expandable');
    }

    #syncHeaderMenuState() {
        const $mainHeader = $('.header');
        const $headerNavRight = $('.header-navigation-right');
        const $navSubMenu = $('.nav-sub-menu');
        const $myWielandMenu = $('.mywieland-sub-menu');
        const $menuClose = $('.menu-close');
        const $dropdownMenu = $('.dropdown-sub-menu');

        const anyMenusOpen = this.#getExpandableMenuItems().filter('.show').length > 0;

        const anyNonLangMenusOpen = this.#getExpandableMenuItems()
            .filter('.show')
            .filter(function () {
                return $(this).closest('.menu-language-wrapper').length === 0;
            }).length > 0;

        const anyLangMenusOpen = this.#getExpandableMenuItems()
            .filter('.show')
            .filter(function () {
                return $(this).closest('.menu-language-wrapper').length > 0;
            }).length > 0;

        $navSubMenu.toggleClass('header-off', anyMenusOpen);
        $mainHeader.toggleClass('header-off', anyMenusOpen);
        $menuClose.toggleClass('header-off', anyNonLangMenusOpen);

        $headerNavRight.toggleClass('header-off', anyNonLangMenusOpen);

        if (anyLangMenusOpen) {
            $dropdownMenu.css('display', 'block');
        }

        if (anyMenusOpen) {
            if ($myWielandMenu.length > 0) {
                $navSubMenu.css('z-index', '-3');
            } else {
                $navSubMenu.css('z-index', '-1');
            }
        } else {
            $navSubMenu.css('z-index', '99');
        }
    }

    #toggle($el, state, animate = false) {
        if (!$el.length) {
            return;
        }

        // Stop any pending animation.
        const $subMenu = $el.children('.sub-menu, ul').stop(true);
        const subMenuCallback = function () {
            // Reset css display property left over by slide animation to not conflict with css styling.
            // $(this).removeAttr('style');
        };

        if (animate) {
            if ($el.hasClass('show')) {
                // Explicitly set sub menu to display block to prevent hiding by class removal.
                $subMenu.css('display', 'block');
            }
            $subMenu[state ? 'slideDown' : 'slideUp']('fast', subMenuCallback);
        } else {
            $subMenu.each(subMenuCallback);
        }

        // Toggle class at last to not influence slide animation.
        $el.toggleClass('show', state);
        this.updateOverlay();
        this.#syncHeaderMenuState();
    }
}
